export default {
  select_size: 'Choisir une taille',
  required: 'Obligatoire',
  required_missing: 'Obligatoire — veuillez faire une sélection',
  optional: 'Facultatif',
  select_up_to: "Sélectionner jusqu'à {{maxCount}}",
};
